/**
 * VendorPortalSocialMediaService
 *
 * Service for vendors to manage their own social media links.
 * Portal API - vendors can only access/modify their own data.
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
export class VendorPortalSocialMediaService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalSocialMediaService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalSocialMediaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all social media links for the authenticated vendor
     */
    async getMySocialMedia() {
        const response = await this.getMySocialMediaRaw();
        if (!response.data) {
            throw new Error('Failed to fetch social media links');
        }
        return response.data;
    }
    /**
     * Get all social media links (raw response)
     */
    async getMySocialMediaRaw() {
        return this.get();
    }
    /**
     * Get a specific social media link by ID
     */
    async getSocialMedia(id) {
        const response = await this.getSocialMediaRaw(id);
        if (!response.data) {
            throw new Error('Social media link not found');
        }
        return response.data;
    }
    /**
     * Get a specific social media link (raw response)
     */
    async getSocialMediaRaw(id) {
        return this.get(String(id));
    }
    /**
     * Create a new social media link
     */
    async createSocialMedia(request) {
        const response = await this.createSocialMediaRaw(request);
        if (!response.data) {
            throw new Error('Failed to create social media link');
        }
        return response.data;
    }
    /**
     * Create a new social media link (raw response)
     */
    async createSocialMediaRaw(request) {
        return this.post('', request);
    }
    /**
     * Update an existing social media link
     */
    async updateSocialMedia(id, request) {
        const response = await this.updateSocialMediaRaw(id, request);
        if (!response.data) {
            throw new Error('Failed to update social media link');
        }
        return response.data;
    }
    /**
     * Update an existing social media link (raw response)
     */
    async updateSocialMediaRaw(id, request) {
        return this.put(String(id), request);
    }
    /**
     * Delete a social media link
     */
    async deleteSocialMedia(id) {
        const response = await this.deleteSocialMediaRaw(id);
        if (!response.success) {
            throw new Error('Failed to delete social media link');
        }
    }
    /**
     * Delete a social media link (raw response)
     */
    async deleteSocialMediaRaw(id) {
        return this.delete(String(id));
    }
}
VendorPortalSocialMediaService.DEFAULT_SERVICE_PATH = 'vendors';
VendorPortalSocialMediaService.BASE_PATH = 'api/vendor-portal/social-media';
//# sourceMappingURL=VendorPortalSocialMediaService.js.map